import { ApiError, submitRanked } from './leaderboard';
import type { InputSegment } from './race-recording';
interface PendingRace { runId: string; playerId: string; segments: InputSegment[]; savedAt: number }
const key = 'tq-ranked-outbox-v1';
export function readOutbox(): PendingRace[] {
  try { const value = JSON.parse(localStorage.getItem(key) ?? '[]'); return Array.isArray(value) ? value.filter(r => r && typeof r.runId === 'string' && typeof r.playerId === 'string' && Number.isFinite(r.savedAt) && r.savedAt > Date.now() - 86400000 && Array.isArray(r.segments)).slice(-5) : []; } catch { return []; }
}
function write(races: PendingRace[]) { try { localStorage.setItem(key, JSON.stringify(races)); return true; } catch { return false; } }
export function queueRace(runId: string, playerId: string, segments: InputSegment[]) {
  const queue = readOutbox().filter(r => r.runId !== runId);
  if (queue.length >= 5) return false;
  return write([...queue, { runId, playerId, segments, savedAt: Date.now() }]);
}
export function removeQueued(runId: string) { write(readOutbox().filter(r => r.runId !== runId)); }
let syncing = false;
export async function retryQueued(playerId: string): Promise<number> {
  if (syncing) return 0;
  syncing = true; let accepted = 0;
  try { for (const race of readOutbox().filter(r => r.playerId === playerId)) {
    try { await submitRanked(race.runId, race.segments); removeQueued(race.runId); accepted++; }
    catch (error) { if (error instanceof ApiError && [400, 404, 409, 413].includes(error.status)) removeQueued(race.runId); else break; }
  } } finally { syncing = false; }
  return accepted;
}
